import { Select } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

export const StyledAppSelect = styled(Select)`
  cursor: pointer;
  min-width: 100px;
  font-size: ${({ theme }) => theme.font.size.base};

  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};

  &.ant-select.ant-select-outlined:not(
      .ant-select-customize-input
    ).ant-select-single
    .ant-select-selector {
    border-color: ${({ theme }) => theme.palette.neutral[300]};
  }

  &.ant-select-disabled {
    .ant-select-selection-item {
      color: ${({ theme }) => theme.palette.text.primary} !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.palette.text.primary} !important;
    }

    &:hover,
    &:focus,
    &:active {
      .ant-select-selector {
        border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
      }
    }
  }

  &:hover,
  &:focus,
  &:active,
  &.ant-select-focused {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.palette.text.disabled};
  }
`;

export const StyledOption = styled(Option)`
  cursor: pointer;
  padding: 8px;
  font-size: ${({ theme }) => theme.font.size.base};
`;
